import React from 'react';
import { BanknoteIcon, BellRingIcon, ShieldCheckIcon } from 'lucide-react';
import { solutions } from '../../data/landingContent';
const icons = [BellRingIcon, ShieldCheckIcon, BanknoteIcon];
export function SolutionsSection() {
  return <section id="solutions" className="scroll-mt-6 bg-white" data-id="element-127" data-mp="1n25dlz11hfex">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-24" data-id="element-128" data-mp="1ryvweu48ap41">
        <div className="max-w-2xl" data-id="element-129" data-mp="2fp9oulqq6pz5">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-130" data-mp="2fqb1gune3kiz">
            How can we help you overcome these challenges?
          </p>
          <h2 className="font-display mt-3 text-2xl font-bold uppercase leading-tight tracking-[0.02em] sm:text-[2.1rem]" data-id="element-131" data-mp="25r29u8fzyhzs">
            Credit Manager is powered by the Satago platform.
          </h2>
          <p className="mt-5 text-base leading-7 text-[#3A3A3A]" data-id="element-132" data-mp="ubwwmai8p11x">
            This powerful suite of credit management and credit control tools
            enables SMEs to adopt the very latest technology and workflow
            automation — making them more efficient at getting paid on time and
            freeing up staff to concentrate on more profitable work. Once the
            system is set up, your involvement can be minimal.
          </p>
          <p className="mt-4 text-base leading-7 text-[#3A3A3A]" data-id="element-133" data-mp="3e6nzd6xvt3af">
            The feedback we hear most from prospective clients is{' '}
            <span className="font-bold text-[#041F60]" data-id="element-134" data-mp="3994fnriezyb3">how simple it is</span>{' '}
            and{' '}
            <span className="font-bold text-[#041F60]" data-id="element-135" data-mp="3j4xszd3yjvtx">
              how inexpensive it is
            </span>
            . The solution was designed to tick both of those boxes.
          </p>
        </div>

        <div className="mt-14 grid border-t border-stone-200 md:grid-cols-3" data-id="element-136" data-mp="3rxj88j8drke0">
          {solutions.map((solution, index) => {
          const Icon = icons[index] || BellRingIcon;
          return <article key={solution.title} className="flex flex-col border-b border-stone-200 py-9 md:border-b-0 md:border-l md:px-8 md:first:border-l-0 md:first:pl-0" data-id="element-137" data-mp="5qb57nkxnpl5" data-mpi={index}>
                <span className="grid h-12 w-12 place-items-center bg-[#4BE4FF] text-[#041F60]" data-id="element-138" data-mp="hrkq1ap1a37x">
                  <Icon size={21} aria-hidden="true" data-id="element-139" data-mp="mr5kb7t9dneb" />
                </span>
                <p className="mt-6 text-xs font-bold uppercase tracking-[0.14em] text-[#5B5299]" data-id="element-140" data-mp="rhvsstwze6d8">
                  {solution.eyebrow}
                </p>
                <h3 className="font-display mt-2 text-lg font-bold uppercase tracking-[0.05em]" data-id="element-141" data-mp="wgyxuecyocl7">
                  {solution.title}
                </h3>
                <p className="mt-3 text-sm leading-6 text-stone-600" data-id="element-142" data-mp="15hf0jllvrfp0">
                  {solution.description}
                </p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}